<template>
	<div class="card">
		<div
			v-if="!$parent.mobile"
			class="card-body d-flex w-100 align-items-center p-3"
		>
			<!-- TITLE -->
			<slot name="title">
				<h6 class="mb-0 text-uppercase font-weight-bold">
					Resultados
					<a-badge
						class="ml-2"
						:count="$parent.data.total"
						:overflow-count="99999"
					/>
					<br>
					<small>Página {{ $parent.page }} de {{ $parent.maxPage }}</small>
				</h6>
			</slot>

			<div class="mr-2" />

			<!-- CUSTOM LEFT -->
			<slot name="head-left" />

			<div class="mr-auto" />

			<!-- CUSTOM RIGHT -->
			<slot name="head-right" />

			<!-- REMOVE FILTERS -->
			<template v-if="$parent.filtered">
				<div class="mr-2" />

				<a-tooltip placement="top">
					<template slot="title">
						Borrar filtros
					</template>
					<a-button
						:disabled="$parent.loading"
						@click="$emit('clean')"
					>
						<fa-icon
							icon="broom"
						/>
					</a-button>
				</a-tooltip>
			</template>

			<!-- SEARCH -->
			<template v-if="!$parent.hideSearch">
				<div class="mr-2" />

				<a-input-search
					v-model="search"
					:class="$style.search"
					placeholder="Buscar.."
					enter-button
					@search="$emit('search', $event)"
				/>
			</template>

			<!-- REFRESH -->
			<template v-if="!$parent.hideRefresh">
				<div class="mr-2" />

				<a-tooltip placement="top">
					<template slot="title">
						Actualizar
					</template>
					<a-button
						:disabled="$parent.loading"
						@click="$parent.list"
					>
						<fa-icon
							icon="sync-alt"
							:spin="$parent.loading"
						/>
					</a-button>
				</a-tooltip>
			</template>
		</div>
		<div v-else>
			<div class="card-body p-3">
				<div class="row">
					<div class="col-12 d-flex align-items-center mb-4">
						<slot
							name="title"
						>
							<h6 class="mb-0 text-uppercase font-weight-bold d-inline-block">
								Resultados
								<a-badge
									class="ml-2"
									:count="$parent.data.total"
									:overflow-count="99999"
								/>
								<br>
								<small>Página {{ $parent.page }} de {{ $parent.maxPage }}</small>
							</h6>
						</slot>

						<template v-if="!$parent.hideRefresh">
							<div class="ml-auto" />

							<a-tooltip placement="top">
								<template slot="title">
									Actualizar
								</template>
								<a-button
									:disabled="$parent.loading"
									@click="$parent.list"
								>
									<fa-icon
										icon="sync-alt"
										:spin="$parent.loading"
									/>
								</a-button>
							</a-tooltip>
						</template>
					</div>
				</div>

				<template v-if="!$parent.hideSearch">
					<div class="row">
						<div class="col">
							<a-input-search
								v-model="$parent.search"
								placeholder="Buscar.."
								enter-button
								@search="$parent.setQuerySearch($event)"
							/>
						</div>
					</div>
				</template>

				<div class="row d-flex">
					<div class="col">
						<slot
							class="mt-4"
							name="head-left"
							:selected="$parent.select"
						/>
					</div>

					<div class="col">
						<slot
							class="mt-4"
							name="head-right"
							:selected="$parent.select"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			search: ''
		};
	},
	created() {
		this.search = this.$parent.search;
	}
};
</script>

<style lang="scss" module>
	.search{
		max-width: 300px;
	}
</style>
